<header
  class="d-flex w-100 align-items-center gap-2 mb-1 rounded"
  style="
    background-color: transparent;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    border-left: 4px solid #cc9213;
  "
>
  <svg
    class="ms-2"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M30 26H28V12C28 11.4696 27.7893 10.9608 27.4142 10.5858C27.0391 10.2107 26.5304 9.99999 26 9.99999H18V3.99999C18.0002 3.63782 17.9021 3.28238 17.7161 2.97161C17.5301 2.66085 17.2633 2.40641 16.944 2.23548C16.6247 2.06454 16.265 1.98351 15.9032 2.00103C15.5415 2.01856 15.1913 2.13398 14.89 2.33499L4.89 8.99999C4.61567 9.18301 4.39086 9.43103 4.23558 9.72196C4.0803 10.0129 3.99937 10.3377 4 10.6675V26H2C1.73478 26 1.48043 26.1053 1.29289 26.2929C1.10536 26.4804 1 26.7348 1 27C1 27.2652 1.10536 27.5196 1.29289 27.7071C1.48043 27.8946 1.73478 28 2 28H30C30.2652 28 30.5196 27.8946 30.7071 27.7071C30.8946 27.5196 31 27.2652 31 27C31 26.7348 30.8946 26.4804 30.7071 26.2929C30.5196 26.1053 30.2652 26 30 26ZM26 12V26H18V12H26ZM6 10.6675L16 3.99999V26H6V10.6675ZM14 14V16C14 16.2652 13.8946 16.5196 13.7071 16.7071C13.5196 16.8946 13.2652 17 13 17C12.7348 17 12.4804 16.8946 12.2929 16.7071C12.1054 16.5196 12 16.2652 12 16V14C12 13.7348 12.1054 13.4804 12.2929 13.2929C12.4804 13.1053 12.7348 13 13 13C13.2652 13 13.5196 13.1053 13.7071 13.2929C13.8946 13.4804 14 13.7348 14 14ZM10 14V16C10 16.2652 9.89464 16.5196 9.70711 16.7071C9.51957 16.8946 9.26522 17 9 17C8.73478 17 8.48043 16.8946 8.29289 16.7071C8.10536 16.5196 8 16.2652 8 16V14C8 13.7348 8.10536 13.4804 8.29289 13.2929C8.48043 13.1053 8.73478 13 9 13C9.26522 13 9.51957 13.1053 9.70711 13.2929C9.89464 13.4804 10 13.7348 10 14ZM10 21V23C10 23.2652 9.89464 23.5196 9.70711 23.7071C9.51957 23.8946 9.26522 24 9 24C8.73478 24 8.48043 23.8946 8.29289 23.7071C8.10536 23.5196 8 23.2652 8 23V21C8 20.7348 8.10536 20.4804 8.29289 20.2929C8.48043 20.1053 8.73478 20 9 20C9.26522 20 9.51957 20.1053 9.70711 20.2929C9.89464 20.4804 10 20.7348 10 21ZM14 21V23C14 23.2652 13.8946 23.5196 13.7071 23.7071C13.5196 23.8946 13.2652 24 13 24C12.7348 24 12.4804 23.8946 12.2929 23.7071C12.1054 23.5196 12 23.2652 12 23V21C12 20.7348 12.1054 20.4804 12.2929 20.2929C12.4804 20.1053 12.7348 20 13 20C13.2652 20 13.5196 20.1053 13.7071 20.2929C13.8946 20.4804 14 20.7348 14 21Z"
      fill="#CC9213"
    />
  </svg>
  <h4 class="fs-5 mt-3">Imóveis</h4>
</header>

<form class="px-3 border rounded">
  <div class="mt-2 mb-2">
    <label class="form-label mt-2 mb-1 fs-6">Você tem imóvel próprio?</label>
    <div class="d-flex flex-row py-2">
      <div class="border hideradio">
        <input
          type="radio"
          class="px-4 py-2 border d-none"
          name="properties"
          id="properties1"
          [value]="1"
          [(ngModel)]="propertiesData.has_property"
          (ngModelChange)="onFieldChange()"
        />
        <label class="form-check-label" for="properties1">Sim</label>
      </div>

      <div class="border hideradio">
        <input
          type="radio"
          class="px-4 py-2 border d-none"
          name="properties"
          id="properties2"
          [value]="0"
          [(ngModel)]="propertiesData.has_property"
          (ngModelChange)="onFieldChange()"
        />
        <label class="form-check-label" for="properties2">Não</label>
      </div>
    </div>
  </div>

  <div class="mb-2 p-2 border-bottom" *ngIf="propertiesData.has_property">
    <div
      class="border-top border-warning pt-2 px-3 mb-3"
      *ngFor="let item of individualsPropertiesLocal; let i = index"
    >
      <app-forms-properties [data]="item" (value)="updateIndividualList($event, i)">
      </app-forms-properties>

      <button
        class="btn btn-outline-danger"
        [id]="'delete-item-property' + i"
        (click)="deleteList(i)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path
            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
          />
        </svg>
        EXCLUIR
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button
    *ngIf="propertiesData.has_property"
      (click)="addList()"
      class="btn btn-outline-primary mb-4"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-plus-lg"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
        />
      </svg>
      Adicionar Imovel
    </button>
  </div>

  <div class="border-top" *ngIf="propertiesData.has_property">
    <label class="form-label mt-3 fs-6"
      >Você gostaria de receber um estudo visando reduzir o seu custo efetivo
      total?</label
    >
    <div class="mt-1 mb-1 ms-1 form-check">
      <input
        class="form-check-input me-2"
        type="checkbox"
        id="interesse"
        name="interesse"
        [checked]="propertiesData.wants_property_study"
        [(ngModel)]="propertiesData.wants_property_study"
        (ngModelChange)="onFieldChange()"
      />
      <label for="interesse">Sim, tenho interesse</label>
    </div>
  </div>
  <!-- <div class="w-100 d-flex justify-content-end mb-2">
    <button
      class="btn mt-3"
      [ngClass]="saveButtonClass"
      [disabled]="isSaving"
      (click)="saveForm()"
    >
      {{ saveButtonText }}
    </button>
  </div> -->
</form>

<app-loading *ngIf="isLoading"></app-loading>